/**
 * Update Study Dialog Context
 *
 * Migrated from: lego/page/etmf/overview/update-study/context/DialogContext.jsx
 *
 * React context for managing Update Study wizard state across all steps.
 */

import { createContext } from 'react'

export interface SelectOption {
  value: number
  label: string
  id: number
  name: string
  mccObjUuid?: string
  mccParentObjUuid?: string
  realId?: number
  isCountry?: boolean
  isSite?: boolean
  siteIds?: string[]
  countryId?: string
}

export interface Selection {
  product?: SelectOption
  study?: SelectOption
  environment?: SelectOption
  countries: SelectOption[]
  sites: SelectOption[]
}

export interface FormValues {
  action: string
  level: string
  product: number | null
  study: number | null
  environment: number | null
  countries: string[]
  sites: string[]
}

export interface ActionOptions {
  add: string
  remove: string
}

export interface LevelOptions {
  countries: string
  sites: string
}

export interface DialogContextValue {
  title: string
  currentStep: number
  isLoading: boolean
  selection: Selection
  actionOptions: ActionOptions
  levelOptions: LevelOptions

  productOptions: SelectOption[]
  studyOptions: SelectOption[]
  environmentOptions: SelectOption[]

  getCurrentValues: () => FormValues
  getDefaultValues: () => FormValues
  getStepName: (num: number) => string | null
  setCurrentValues: (vals: Partial<FormValues>, setValues: (values: FormValues) => void) => FormValues
  goToNextStep: (values: FormValues) => void
  goToPreviousStep: () => void
  loadStudyOptions: () => Promise<void>
  loadEnvironmentOptions: () => Promise<void>
  loadCountryOptions: (params: { sortDesc: boolean }) => Promise<{
    elements: SelectOption[]
    totalElements: number
    isCached: boolean
  }>
  loadSiteOptions: (params: { sortDesc: boolean }) => Promise<{
    elements: SelectOption[]
    totalElements: number
    isCached: boolean
  }>
  submit: (values: FormValues) => Promise<void>
}

export const DialogContext = createContext<DialogContextValue | null>(null)
